var $59d9df99e04ee555$exports = {};
$59d9df99e04ee555$exports = {
    "(optional)": `(valgfrit)`,
    "(required)": `(obligatorisk)`
};


export {$59d9df99e04ee555$exports as default};
//# sourceMappingURL=da-DK.module.js.map
